var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.238 2H11.344C9.58005 2 8.18205 2 7.08905 2.148C5.96305 2.3 5.05205 2.62 4.33405 3.341C3.61505 4.062 3.29605 4.977 3.14505 6.107C2.99805 7.205 2.99805 8.608 2.99805 10.379V16.217C2.99805 17.725 3.91805 19.017 5.22505 19.559C5.15805 18.649 5.15805 17.374 5.15805 16.312V11.302C5.15805 10.021 5.15805 8.916 5.27605 8.032C5.40305 7.084 5.68905 6.176 6.42305 5.439C7.15705 4.702 8.06205 4.415 9.00605 4.287C9.88605 4.169 10.986 4.169 12.263 4.169H15.333C16.609 4.169 17.707 4.169 18.588 4.287C18.3242 3.61329 17.8634 3.03474 17.2658 2.62678C16.6682 2.21883 15.9616 2.00041 15.238 2Z",
    fill: "#08090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 11.3963C6.59961 8.67028 6.59961 7.30728 7.44361 6.46028C8.28661 5.61328 9.64361 5.61328 12.3596 5.61328H15.2396C17.9546 5.61328 19.3126 5.61328 20.1566 6.46028C21.0006 7.30728 20.9996 8.67028 20.9996 11.3963V16.2163C20.9996 18.9423 20.9996 20.3053 20.1566 21.1523C19.3126 21.9993 17.9546 21.9993 15.2396 21.9993H12.3596C9.64461 21.9993 8.28661 21.9993 7.44361 21.1523C6.59961 20.3053 6.59961 18.9423 6.59961 16.2163V11.3963Z",
    fill: "#08090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copy_dark.c57ba4061687cbd2014e83e35f400b25.svg";
export { ForwardRef as ReactComponent };